import * as Yup from 'yup';

export const ValidationSchema = Yup.object({
  name: Yup.string().required('Property type must not be empty').trim(),
  propertyType: Yup.number().nullable().required('Please Select Property Type'),
  bankAccountType: Yup.string()
    .nullable()
    .required('Please Select Account Type'),
  accountNumber: Yup.string().matches(
    /^[0-9]{6}/,
    'Enter valid account number'
  ),
  routingNumber: Yup.string().matches(
    /^[0-9]{9}$/,
    'Routing number must have 9 characters'
  ),
});

export const ValidationMassTransfer = Yup.object({
  propertyId: Yup.number().nullable().required('Please Select Property'),
  rentAmount: Yup.string().required('Please enter rent amount'),
  loanRepayment: Yup.string().required('Please enter loan payment'),
  insurance: Yup.string().required('Please enter insurance'),
  propertyTax: Yup.string().required('Please enter property tax'),
  managementFees: Yup.string().required('Please enter management fees'),
  otherExpenses: Yup.string().required('Please enter other expenses'),
});
